var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIlAppicon80Px = function SvgIlAppicon80Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 81,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10.64px)",
      clipPath: "url(#il_appicon_80px_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 21.283
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5C0 9.454 8.954.5 20 .5h40c11.046 0 20 8.954 20 20v40c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-40Z",
    fill: "#000",
    style: {
      mixBlendMode: "luminosity"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5C0 9.454 8.954.5 20 .5h40c11.046 0 20 8.954 20 20v40c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-40Z",
    fill: "url(#il_appicon_80px_svg__b)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.333 20.5C.333 9.638 9.138.833 20 .833h40c10.862 0 19.667 8.805 19.667 19.667v40c0 10.862-8.805 19.667-19.667 19.667H20C9.138 80.167.333 71.362.333 60.5v-40Z",
    stroke: "url(#il_appicon_80px_svg__c)",
    strokeOpacity: 0.1,
    strokeWidth: 0.667
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.839 42.637c2.004-.741 3.04-3.716 3.04-5.877 0-3.121-1.707-6.472-5.711-7.213-1.334-.225-5.49-.225-7.942-.225v5.356h5.046c1.928 0 3.041 1.116 3.041 2.75 0 1.635-.89 2.751-3.114 2.751h-4.005v5.502h4.75c1.853 0 3.338.893 3.338 2.825 0 1.711-1.26 2.824-3.338 2.824h-8.238V25.38h4.822c13.8 0 15.804 10.34 15.804 19.636v2.976h5.49V44.87c0-11.75-3.709-24.694-23.226-24.694H21.313v5.204h6.826v31.313h13.654c6.457 0 8.978-2.902 8.978-7.882 0-3.346-1.854-5.355-3.932-6.175Z",
    fill: "#00E1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.181 50.968a76.818 76.818 0 0 0 0 5.8c1.928.073 3.86.073 5.786 0a76.504 76.504 0 0 0 0-5.8 76.453 76.453 0 0 0-5.785 0Z",
    fill: "#00E1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "il_appicon_80px_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(122.178 35.76 16.378) scale(164.618 140.626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#05CBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_appicon_80px_svg__c",
    x1: 8.126,
    y1: 2.196,
    x2: 41.617,
    y2: 85.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#C3DCEA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#766E80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fff",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "il_appicon_80px_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5C0 9.454 8.954.5 20 .5h40c11.046 0 20 8.954 20 20v40c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-40Z"
  })))));
};
export default SvgIlAppicon80Px;